<template>
  <div>
    <h1 class="mb-0">Send reset code</h1>
    <p>Enter your username and reset code will be sent to your email.</p>
    <SendResetCodeForm />
  </div>
</template>

<script>
import SendResetCodeForm from "./Forms/SendResetCodeForm.vue";

export default {
  name: "SendResetCode",
  components: { SendResetCodeForm }
};
</script>
